/**
 * Shared warranty FAQ used on the about “Our Guarantee” accordion
 * and appended to the homepage FAQ list.
 */
export type WarrantyFaqItem = {
  q: string;
  a: string;
};

export const warrantyFaqItems: WarrantyFaqItem[] = [
  {
    q: "What does the Revolin workmanship warranty cover?",
    a: "Every completed job includes a written Revolin workmanship warranty covering installation work performed by Revolin Roofing under the signed project scope. Exact term, inclusions, exclusions and claim steps are stated in the warranty document issued with your project.",
  },
  {
    q: "How does the manufacturer material warranty work?",
    a: "Material warranties are issued by the product manufacturer. Coverage depends on the system installed and whether the installation meets that manufacturer’s requirements. When Revolin completes a qualifying manufacturer-certified installation for the brands we install, the project may be eligible for the manufacturer’s enhanced material warranty terms.",
  },
  {
    q: "What should I keep for a warranty claim?",
    a: "Keep your signed scope, final invoice, warranty certificates and any manufacturer registration confirmation. Contact Revolin Roofing first for workmanship questions; material claims follow the manufacturer’s process and may still require installation records from us.",
  },
];

export const guaranteeCards = [
  {
    id: "workmanship",
    title: "Revolin Workmanship Warranty",
    body: "Every completed job includes a written workmanship warranty covering Revolin Roofing’s installation under the agreed scope. The controlling term and conditions are issued in writing with your project - not left as a verbal assurance.",
  },
  {
    id: "manufacturer",
    title: "Manufacturer Material Warranty",
    body: "Manufacturer material warranties follow the product system selected for your roof. Qualifying manufacturer-certified installations for the brands we install may unlock enhanced material warranty coverage from the manufacturer. Revolin registers and documents eligible installations as required by the program.",
  },
] as const;
